module.exports = __webpack_public_path__ + "img/中度霾.de07eb2f.png";